import FadeLoader from "react-spinners/FadeLoader";
import Spin from 'antd/es/spin'
import studentLoader from '@assets/animates/studentLoader.gif'
const sizes = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-16 w-16',
  xl: 'h-24 w-24',
};

const variants = {
  light: 'text-white',
  primary: 'text-blue-600',
};

export type SpinnerProps = {
  size?: keyof typeof sizes;
  variant?: keyof typeof variants;
  className?: string;
};

export const Spinner = ({
  size = 'md',
  variant = 'primary',
  className = '',
}: SpinnerProps) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-15 z-40 flex items-center justify-center">
        {/* <FadeLoader color="#F17A20" /> */}
        <Spin tip="Loading..." size="large"/>
    </div>
  );
};

export const StudentSpinner = () => {
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-transparent">
      <img src={studentLoader} alt="Loading..." className="w-64 h-64 opacity-50" />
    </div>
  );
}

export { ContainerLoader } from './ContainerLoader';
export type { ContainerLoaderProps } from './ContainerLoader';
